import React, { useEffect } from "react";

import { CreateCallOffCode } from "../create-call-off-code";
import { FC } from "react";
import { PartitionDetails } from "./EnterPartitionDetailsTypes";
import { TextField } from "@mui/material";
import localisation from "../../localisation";

type PartitionDetailsProps = {
    details?: PartitionDetails;
    onChange: (newValue: PartitionDetails) => void;
    onValidChanged?: (isValid: boolean) => void;
};

const nullDetails = (): PartitionDetails => ({
    name: null,
    reference: null,
    emailAddress: null,
    notes: null,
    callOffCodes: [],
});

const EnterPartitionDetails: FC<PartitionDetailsProps> = ({ details = nullDetails(), onChange, onValidChanged }) => {
    type SetterFunction = (details: PartitionDetails, value: string | null) => void;
    type ChangeEventFunction = (event: React.ChangeEvent<HTMLInputElement>) => void;

    const testIsValid = ({ name, reference, emailAddress }: PartitionDetails): boolean =>
        (name ?? "").trim().length > 0 && (reference ?? "").trim().length > 0 && (emailAddress ?? "").trim().length > 0;

    const [isValid, setIsValid] = React.useState(() => testIsValid(details));

    useEffect((): void => {
        setIsValid(testIsValid(details));
    }, [details]);

    useEffect((): void => {
        onValidChanged?.(isValid);
    }, [isValid, onValidChanged]);

    const handleChange =
        (setter: SetterFunction): ChangeEventFunction =>
        (event) => {
            setter(details, event.target.value === "" ? null : event.target.value);
            onChange(details);
        };

    const { nameLabel, referenceLabel, ownerEmailLabel, notesLabel } = localisation;

    const { nameHelperText, referenceHelperText, ownerEmailHelperText, notesHelperText } = localisation;

    return (
        <form>
            <TextField
                id="partition-name-field"
                required
                label={nameLabel}
                style={{ margin: 8 }}
                helperText={nameHelperText}
                fullWidth
                margin="normal"
                value={details.name ?? ""}
                onChange={handleChange((x, value) => (x.name = value))}
            />
            <TextField
                id="reference-field"
                label={referenceLabel}
                style={{ margin: 8 }}
                helperText={referenceHelperText}
                fullWidth
                margin="normal"
                value={details.reference ?? ""}
                onChange={handleChange((x, value) => (x.reference = value))}
            />
            <TextField
                id="email-field"
                label={ownerEmailLabel}
                type="email"
                style={{ margin: 8 }}
                helperText={ownerEmailHelperText}
                fullWidth
                margin="normal"
                value={details.emailAddress ?? ""}
                onChange={handleChange((x, value) => (x.emailAddress = value))}
            />
            <CreateCallOffCode
                onCallOffCodesChanged={(newCallOffCodes: string[]) => {
                    details.callOffCodes = newCallOffCodes;
                    onChange(details);
                }}
                callOffCodes={details.callOffCodes}
            ></CreateCallOffCode>
            <TextField
                id="notes-field"
                label={notesLabel}
                style={{ margin: 8 }}
                helperText={notesHelperText}
                fullWidth
                margin="normal"
                multiline={true}
                rows={5}
                value={details.notes ?? ""}
                onChange={handleChange((x, value) => (x.notes = value))}
            />
        </form>
    );
};

export default EnterPartitionDetails;
